import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import './MessagePreviewStyle.css'
import '../ModalStyle.css'
import { VARIABLE_LIST } from '@constants/Marketing'
import { IEmailEditorCanvas } from '@dataTypes/marketing.type'
import { emailCanvasCssVars } from '@utils/marketingTemplate.util'
import { sanitizeEmailHtml } from '@utils/sanitize-html.util'

import { logger } from '@utils/safeLogger'

type MessagePreviewProps = {
  content: string
  show: boolean
  onHide: () => void
  showSampleValue?: boolean
  channel?: string
  subject?: string
  emailCanvas?: IEmailEditorCanvas
}

const MessagePreviewModal: React.FC<MessagePreviewProps> = ({
  content,
  show,
  onHide,
  showSampleValue = false,
  channel = 'SMS',
  subject,
  emailCanvas,
}) => {
  const isEmail = channel === 'Email'

  const replaceVariables = (rawHtml: string): string => {
    try {
      const parser = new DOMParser()
      const doc = parser.parseFromString(rawHtml, 'text/html')

      const spans = doc.querySelectorAll('span.e-mention-chip')

      spans.forEach((span) => {
        const variableText = span.textContent?.trim()
        if (variableText) {
          // Find the matching variable in VARIABLE_LIST
          const variable = VARIABLE_LIST.find((v) => v.text === variableText)
          if (variable) {
            // Replace the span content with the sample value
            span.textContent = variable.sample
            // Remove the e-mention-chip class to show it as regular text
            span.classList.remove('e-mention-chip')
          }
        }
      })

      return doc.body.innerHTML
    } catch (error) {
      logger.error('Error processing preview content:', error)
      return rawHtml
    }
  }

  const [updatedContent, setUpdatedContent] = useState<string>(
    showSampleValue ? replaceVariables(content) : content,
  )

  useEffect(() => {
    setUpdatedContent(showSampleValue ? replaceVariables(content) : content)
  }, [content, showSampleValue])

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className={`message-preview-modal${isEmail ? ' message-preview-modal--email' : ''}`}
      id="message-preview-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Message preview</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isEmail ? (
          <div className="message-preview-content message-preview-content--email">
            <div className="mpc-email-frame">
              {subject !== undefined && subject !== '' && (
                <div className="mpc-email-subject">
                  <span className="mpc-email-subject-label">Subject</span>
                  <span className="mpc-email-subject-value">{subject}</span>
                </div>
              )}
              <div
                className="mpc-text mpc-text--email mt-marketing-email-tpl-root"
                style={emailCanvasCssVars(emailCanvas)}
                dangerouslySetInnerHTML={{
                  __html: sanitizeEmailHtml(updatedContent),
                }}
              />
            </div>
          </div>
        ) : (
          <div className="message-preview-content">
            <div className="mpc-inner">
              <div
                className="mpc-text"
                dangerouslySetInnerHTML={{
                  __html: sanitizeEmailHtml(updatedContent),
                }}
              />
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  )
}

export default MessagePreviewModal
